import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Auto-picks the best Forge Story language for the current user:
 * 1. First user language that has forge stories available
 * 2. Otherwise any available language
 * 3. Otherwise falls back to /forge
 */
export default function ForgeStoriesIndex() {
  const navigate = useNavigate();

  useEffect(() => {
    const pickLanguage = async () => {
      try {
        const [langsRes, userLangsRes] = await Promise.all([
          axios.get(`${BACKEND_URL}/api/forge-stories/languages`),
          axios.get(`${BACKEND_URL}/api/users/me/languages`, { withCredentials: true }).catch(() => null),
        ]);

        const available = (langsRes.data?.languages || []).map((l) => l.code);
        const userLangs = userLangsRes?.data?.languages || [];
        const userCodes = userLangs.map((l) => l.code || l.language_code).filter(Boolean);

        const match = userCodes.find((c) => available.includes(c));
        if (match) {
          navigate(`/forge-stories/${match}`, { replace: true });
          return;
        }

        if (available.length > 0) {
          navigate(`/forge-stories/${available[0]}`, { replace: true });
          return;
        }

        navigate('/forge', { replace: true });
      } catch {
        navigate('/forge', { replace: true });
      }
    };
    pickLanguage();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh] text-muted-foreground" data-testid="forge-stories-index">
      <Loader2 className="w-6 h-6 animate-spin mr-2" />
      Loading Story Path…
    </div>
  );
}
